var map = {
	"./gallery-wip-pommel_00.jpg": 5005,
	"./gallery-wip-pommel_01.jpg": 5006,
	"./gallery-wip-pommel_02.jpg": 5007,
	"./gallery-wip-pommel_03.jpg": 5008,
	"./gallery-wip-pommel_04.jpg": 5009,
	"./gallery-wip-pommel_05.jpg": 5010,
	"./gallery-wip-pommel_06.jpg": 5011,
	"./gallery-wip-pommel_07.jpg": 5012,
	"./gallery-wip-pommel_08.jpg": 5013,
	"./gallery-wip-pommel_09.jpg": 5014,
	"./gallery-wip-pommel_10.jpg": 5015,
	"./gallery_00.jpg": 5016,
	"./gallery_01.jpg": 5017,
	"./gallery_02.jpg": 5018,
	"./gallery_03.jpg": 5019,
	"./gallery_04.jpg": 5020,
	"./gallery_05.jpg": 5021,
	"./gallery_06.jpg": 5022,
	"./gallery_07.jpg": 5023,
	"./gallery_08.jpg": 5024,
	"./gallery_09.jpg": 5025,
	"./gallery_10.jpg": 5026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5004;